import {useMutation} from '@tanstack/react-query';
import api from 'services/api';

const useUserDelete = () => {
    const userDelete = async (req) => {

        try {
            const query = new URLSearchParams({});

            query.append('organization_id', req.orgId);

            query.append('support_ticket_id', req.support_ticket_id);

            if (req.requested_by) {
                query.append('requested_by', req.requested_by);
            }
            if (req.reason) {
                query.append('reason', req.reason);
            }

            const response = await api.delete(
                `api/v1/users/${req.userId}?${query.toString()}`
            );

            const data = await response.json();

            return data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    };

    return useMutation(({req}) => userDelete(req), {});
};

export default useUserDelete;